import { pageInfo, exportData, addData, deleteData, updateData, importData, downloadTemplate ,initEdit} from '../api/index';
import { listShipper,areaTree} from '../../../../api/selects';
import { Message } from 'element-ui';
import { companyListData } from '../../company/api'
const addr = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    exportDataObj: null,
    shipperObj: null,
    areaObj: null,
    deleteDataObj: null,
    addDataObj: null,
    updateDataObj: null,
    downloadTemplateObj: null,
    importDataObj: null,
    initEditObj: null,
    companyObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    EXPORT_DATA(state, data) {
      state.exportDataObj = data;
    },
    ADD_DATA(state, data) {
      state.addDataObj = data;
    },
    DELETE_DATA(state, data) {
      state.deleteDataObj = data;
    },
    UPDATE_DATA(state, data) {
      state.updateDataObj = data;
    },
    DOWNLOAD_TEMPLATE(state, data) {
      state.downloadTemplateObj = data;
    },
    IMPORT_DATA(state, data) {
      state.importDataObj = data;
    },
    LIST_SHIPPER(state, data) {
      state.shipperObj = data.obj;
    },
    LIST_AREA(state, data) {
      state.areaObj = data.obj;
    },
    INIT_EDIT(state, data) {
      state.initEditObj = data;
    },
    LIST_COMPANY(state, data) {
      state.companyObj = data.obj;
    },
  },
  actions: {
    //查询
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //导出文件
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //添加删除
    async addData({ commit }, obj) {
      let resp = await addData(obj);
      commit('ADD_DATA', resp);
    },
    //删除数据
    async deleteData({ commit }, obj) {
      let resp = await deleteData(obj);
      commit('DELETE_DATA', resp);
    },
    //修改数据
    async updateData({ commit }, obj) {
      let resp = await updateData(obj);
      commit('UPDATE_DATA', resp);
    },
    //下载模板
    async downloadTemplate({ commit }, obj) {
      let resp = await downloadTemplate(obj);
      commit('DOWNLOAD_TEMPLATE', resp);
    },
    //导入数据
    async importData({ commit }, obj) {
      let resp = await importData(obj);
      commit('IMPORT_DATA', resp);
    },
    //企业
    async listShipper({ commit }, obj) {
      let resp = await listShipper(obj);
      commit('LIST_SHIPPER', resp);
    },
    async listArea({ commit }, obj) {
      let resp = await areaTree(obj);
      commit('LIST_AREA', resp);
    },
    //修改数据
    async initEdit({ commit }, obj) {
      let resp = await initEdit(obj);
      commit('INIT_EDIT', resp);
    },
    /**
     * 机构查询
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async listCompany({ commit }, obj) {
      let resp = await companyListData(obj);
      commit('LIST_COMPANY', resp);
    },
  }
}
export default addr



// WEBPACK FOOTER //
// ./src/page/mdm/addr/store/addr.store.js